import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class probono extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                ​

                ​




                ​










            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >
                    {lang==="en" && <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>Pro Bono</span><p/>
                        <span style={{fontSize: ".8em"}}>The Morrow Firm maintains an active pro bono practice, because we believe in giving back to the community and helping those in need.</span><p/>

                        <span style={{fontSize: ".8em"}}>Representative experience:</span><p/>
                        ​

                        <ul><span style={{fontSize: ".8em"}}><li>Successfully appealed a FEMA decision for a family whose home in the American Samoa was destroyed by Hurricane Gita.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Obtained default judgment and favorable settlement for a veteran who was defrauded out of his home through a loan modification scam.</li></span><br/>

                            <span style={{fontSize: ".8em"}}><li>Obtained a U visa for an undocumented immigrant who assisted law enforcement in the investigation and prosecution of a crime against a child.</li></span><br/></ul>

                    </div>}
                    {lang==="zh" && <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>法律援助</span><p/>
                        <span style={{fontSize: ".8em"}}>沫若律师事务所提供法律援助，因为我们相信回馈社区并帮助那些有需要的人。</span><p/>

                        <span style={{fontSize: ".8em"}}>代表经验：</span><p/>
                        ​

                        <ul><span style={{fontSize: ".8em"}}><li>成功地为一个家庭上诉联邦紧急事务管理局（FEMA）决定。该家庭在美属萨摩亚的家被飓风摧毁，而联邦紧急事务管理局（FEMA）最初未能提供足够补偿。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>为一位被贷款修改诈骗骗取了住房的退伍老兵获得了默认判决和有利的庭外和解。</li></span><br/>

                            <span style={{fontSize: ".8em"}}><li>为一位协助执法部门调查和起诉侵害儿童的罪行的无证移民取得了U签证。</li></span><br/></ul>

                    </div>}


                    <div style={{width: "49%", maxWidth:"50%",  height:"100%", minWidth:"20em",verticalAlign:"top", display: "inline-block",  padding: "5px", top:"0px", }} ><img  alt="Pro Bono" style={{top:"0px", width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/probono.jpg?alt=media&token=727bbb14-9503-476e-b7bc-a84e9ab1e6b6"/>

                    </div>
                </div>
            </div>
            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang  };
}

export default connect(mapStateToProps, { getUser})(probono);



// WEBPACK FOOTER //
// ./src/Containers/probono.js